import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/header/header";
import QuestionnairePage from "./pages/questionnairePage/questionnairePage";
import HraResultPage from "./pages/resultsPage/userResultPage/hraResultPage";
import HraAnalyticsPage from "./pages/analiticsPage/hraAnalyticsPage";
import EstresResultPage from "./pages/resultsPage/userResultPage/estresResultPage";
import StressAnalyticsPage from "./pages/analiticsPage/stressAnalyticsPage";
import LoginPage from "./pages/loginPage/LoginPage";
import Unauthorized from "./pages/Unauthorized.js";
import PrivateRoute from "./components/PrivateRoute";
import "./App.css";
import HraAnalyticsGlobalPage from "./pages/analiticsPage/hraAnalyticsGlobalPage.js";
import StressAnalyticsGlobalPage from "./pages/analiticsPage/stressAnalyticsGlobalPage.js";
import CompaniesPage from "./pages/CompaniesPage/CompaniesPage.jsx";
import Dashboard from "./pages/Dashboard/Dashboard.jsx";
import CreateCompanyPage from "./pages/CreateCompanyPage/CreateCompanyPage.js";
import UpdateCompanyPage from "./pages/UpdateCompanyPage/UpdateCompanyPage.js";
import BranchConfigurationPage from "./pages/BranchConfigurationPage/BranchConfigurationPage.js";
import UpdatePasswordPage from "./pages/updatePasswordPage/UpdatePasswordPage.js";
import ConfiguracionPage from "./pages/ConfiguracionPage/ConfiguracionPage.js";
import Nom035AnalyticsPage from "./pages/analiticsPage/Nom035AnalyticsPage.js";
import Nom035GloablAnalyticsPage from "./pages/analiticsPage/Nom035AnalyticsGlobalPage.js";
import Nom035SecIAnalyticsPage from "./pages/analiticsPage/Nom035SecIAnalyticsPage.js";
import Nom035SecIAnalyticsGlobalPage from "./pages/analiticsPage/Nom035SecIAnalyticsGlobalPage.js";
import CgsAnalyticsPage from "./pages/analiticsPage/CgsAnalyticsPage.js";
import CgsAnalyticsGlobalPage from "./pages/analiticsPage/CgsAnalyticsGlobalPage.js";
import ThankYouPage from "./pages/resultsPage/userResultPage/nom035Results.js";
import Nom035SecIResults from "./pages/resultsPage/userResultPage/nom035SecIResults.js";
import CgsResults from "./pages/resultsPage/userResultPage/cgsResults.js";
import SuperAdminsPage from "./pages/SuperAdminsPage/SuperAdminsPage.js";
import AdminsPage from "./pages/AdminsPage/AdminsPage.js";
import HbResultPage from "./pages/resultsPage/userResultPage/hbResultPage.js";
import HbAnalyticsPage from "./pages/analiticsPage/hbAnalyticsPage.js";
import HbAnalyticsGlobalPage from "./pages/analiticsPage/hbAnalyticsGlobalPage.js";
import CompanyDashboardPage from "./pages/CompanyDashboardPage/CompanyDashboardPage.jsx";
import AdminCompanyDashboardPage from "./pages/AdminCompanyDashboardPage/AdminCompanyDashboardPage.jsx";
import TwoFactorSetupPage from "./pages/TwoFactorSetupPage/TwoFactorSetupPage.jsx";
import NutriologyDashboard from "./pages/NutrilogyPanel/NutriologyDashboard.jsx";
import ReviewPage from "./pages/ReviewPage/ReviewPage.jsx";

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Rutas donde no se quiere el Header
  const noHeaderRoutes = ["/login", "/unauthorized"];
  const noHeaderPrefixes = ["/nutrilogyPanel", "/review"];
  const showHeader = !noHeaderRoutes.includes(location.pathname)
    && !noHeaderPrefixes.some(prefix => location.pathname.startsWith(prefix));

  // Aplica padding solo si se renderiza el Header
  const contentStyle = {
    paddingTop: showHeader ? (isMobile ? "130px" : "60px") : "0",
  };

  return (
    <>
      {showHeader && <Header />}
      <div className="content" style={contentStyle}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/review/:hashId" element={<ReviewPage />} />
          <Route path="/:questionnaire/:idEmpresa" element={<QuestionnairePage />} />
          <Route path="/:questionnaire/:idEmpresa/:applicationId" element={<QuestionnairePage />} />
          <Route path="/hra/results" element={<HraResultPage />} />
          <Route path="/nom035/results" element={<ThankYouPage />} />
          <Route path="/nom035SecI/results" element={<Nom035SecIResults />} />
          <Route path="/cgs/results" element={<CgsResults />} />
          <Route path="/estres/results" element={<EstresResultPage />} />
          <Route path="/hb/results" element={<HbResultPage />} />
          <Route path="/users/password/:token" element={<UpdatePasswordPage />} />

          <Route
            path="/"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/empresas"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <CompaniesPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/hraConfiguracion"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <ConfiguracionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/superAdminConfig"
            element={
              <PrivateRoute allowedRoles={["root user"]}>
                <SuperAdminsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/adminConfig"
            element={
              <PrivateRoute allowedRoles={["root user", "super admin"]}>
                <AdminsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/nutriologyConfig"
            element={
              <PrivateRoute allowedRoles={["root user", "super admin"]}>
                <AdminsPage userRole="nutriology" />
              </PrivateRoute>
            }
          />
         
            <Route
              path="/company"
              element={<PrivateRoute allowedRoles={["super admin", "root user"]}><CreateCompanyPage /></PrivateRoute>}
            />
          <Route
              path="/company/:idCompany"
              element={<PrivateRoute allowedRoles={["super admin", "root user"]}><UpdateCompanyPage /></PrivateRoute>}
            />
          <Route
              path="/company/:idCompany/branches/:branchId/configure"
              element={<PrivateRoute allowedRoles={["super admin", "root user"]}><BranchConfigurationPage /></PrivateRoute>}
            />
    
          <Route
            path="/analytics/hra/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <HraAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/hra/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <HraAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/hb/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <HbAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/hb/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <HbAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035/branch/:branchId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035AnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035/company/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035AnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035AnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035AnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035SecI/branch/:branchId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035SecIAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035SecI/company/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035SecIAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035SecI/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035SecIAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035SecI/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <Nom035SecIAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealtquestionarie/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealtquestionarie/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealthquestionarie/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealthquestionarie/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealthquestionnaire/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealthquestionnaire/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealtquestionnaire/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/generalhealtquestionnaire/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <CgsAnalyticsPage />
              </PrivateRoute>
            }
          />
          {/* Dashboard de sucursal exclusivo para administradores */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <AdminCompanyDashboardPage
                  key={location.state?.branchId || location.state?.companyId || "dashboard"}
                />
              </PrivateRoute>
           }
          />
          <Route
            path="/nutrilogyPanel"
            element={
              <PrivateRoute allowedRoles={["nutriology"]}>
                <NutriologyDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/nutrilogyPanel/patients/:patientId"
            element={
              <PrivateRoute allowedRoles={["nutriology"]}>
                <NutriologyDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/hra/global"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <HraAnalyticsGlobalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/hb/global"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <HbAnalyticsGlobalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/estresBurnout/global"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <StressAnalyticsGlobalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035/global"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <Nom035GloablAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/nom035SecI/global"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <Nom035SecIAnalyticsGlobalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/ghq/global"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <CgsAnalyticsGlobalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/estresBurnout/:branchId/:applicationId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <StressAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics/estresBurnout/:companyId"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <StressAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/:companyId/dashboard"
            element={
              <PrivateRoute allowedRoles={["super admin", "root user"]}>
                <CompanyDashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/2fa/configuracion"
            element={
              <PrivateRoute allowedRoles={["admin", "super admin", "root user"]}>
                <TwoFactorSetupPage />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
